<template>
  <template v-if="productModifierGroup">
    <div class="flex w-full justify-between p-2">
      <div>
        <div class="flex items-center justify-start">
          <span
            class="text-lg font-medium text-background-fg/87"
          >
            {{ productModifierGroup.label }}
          </span>
          <template v-if="productModifierGroup.isShared">
            <span
              class="ml-2 rounded-full border border-primary px-1 py-px text-xs text-primary"
            >
              shared
            </span>
          </template>
        </div>
        <div class="space-x-2 text-left">
          <template
            v-for="option in productModifierGroup.options"
            :key="option.id"
          >
            <span
              class="text-xs font-medium text-background-fg/70"
            >
              - {{ option.label }}
            </span>
          </template>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <div> broken </div>
  </template>
</template>

<script setup lang="ts">
const props = defineProps<{
  productModifierGroupId: string
}>()

const emit = defineEmits<{
  (event: "edit", params: string): void
}>()
const { getById } = useProductModifierGroups()

const productModifierGroup = getById(
  toRef(props, "productModifierGroupId")
)
</script>
